import React from "react";
import { marked } from "marked";

// Render Markdown as React elements: raw HTML and non-web link protocols stay inert.
const safeLink = (href) => {
  if (!href || !/^(https?:\/\/|\/(?!\/)|#)/i.test(href)) return null;
  return href;
};

const renderTokens = (tokens = []) =>
  tokens.map((token, index) => {
    const children = token.tokens ? renderTokens(token.tokens) : token.text;
    switch (token.type) {
      case "space":
        return null;
      case "paragraph":
        return <p key={index}>{children}</p>;
      case "text":
        return <React.Fragment key={index}>{children}</React.Fragment>;
      case "strong":
        return <strong key={index}>{children}</strong>;
      case "em":
        return <em key={index}>{children}</em>;
      case "del":
        return <del key={index}>{children}</del>;
      case "br":
        return <br key={index} />;
      case "heading":
        return <h4 key={index}>{children}</h4>;
      case "codespan":
        return <code key={index}>{token.text}</code>;
      case "code":
        return (
          <pre key={index}>
            <code>{token.text}</code>
          </pre>
        );
      case "blockquote":
        return <blockquote key={index}>{children}</blockquote>;
      case "list": {
        const List = token.ordered ? "ol" : "ul";
        return (
          <List key={index}>
            {token.items.map((item, itemIndex) => (
              <li key={itemIndex}>{renderTokens(item.tokens)}</li>
            ))}
          </List>
        );
      }
      case "link": {
        const href = safeLink(token.href);
        return href ? (
          <a
            key={index}
            href={href}
            target={/^https?:/i.test(href) ? "_blank" : undefined}
            rel="noopener noreferrer"
          >
            {children}
          </a>
        ) : (
          <React.Fragment key={index}>{children}</React.Fragment>
        );
      }
      case "hr":
        return <hr key={index} />;
      case "image":
        return <span key={index}>{token.text}</span>;
      default:
        return (
          <React.Fragment key={index}>
            {token.text || token.raw || ""}
          </React.Fragment>
        );
    }
  });

const CustomChatMessage = ({ message }) => (
  <div className="compass-markdown">
    {renderTokens(marked.lexer(String(message || "")))}
  </div>
);
export default CustomChatMessage;
